import { SortBy, SortOrder } from "./LicenseSortParams"
import { SortUtils } from "./SortUtils"

export class LicenseSort {

  public static sortLinesTable(a: any, b: any, sortOrder: SortOrder, sortBy: SortBy) {
    if (sortOrder === SortOrder.ASCENDING) {
      if (sortBy === SortBy.SYSTEM_ID) {
        return SortUtils.sortStrings(a.systemId, b.systemId)
      }
      else if (sortBy === SortBy.HOST_TYPE) {
        return SortUtils.sortStrings(a.hostIdType, b.hostIdType)
      }
      else if (sortBy === SortBy.HOST_ID) {
        return SortUtils.sortStrings(a.hostId, b.hostId)
      }
      else if (sortBy === SortBy.PARTIAL_FULFILLMENT) {
        return SortUtils.sortNumbers(a.fulfillmentSize, b.fulfillmentSize)
      }
    }
    else if (sortOrder === SortOrder.DESCENDING) {
      if (sortBy === SortBy.SYSTEM_ID) {
        return SortUtils.sortStrings(b.systemId, a.systemId)
      }
      else if (sortBy === SortBy.HOST_TYPE) {
        return SortUtils.sortStrings(b.hostIdType, a.hostIdType)
      }
      else if (sortBy === SortBy.HOST_ID) {
        return SortUtils.sortStrings(b.hostId, a.hostId)
      }
      else if (sortBy === SortBy.PARTIAL_FULFILLMENT) {
        return SortUtils.sortNumbers(b.fulfillmentSize, a.fulfillmentSize)
      }
    }

    return 0
  }

  public static sortDealsTable(a: any, b: any, sortOrder: SortOrder, sortBy: SortBy) {
    if (sortOrder === SortOrder.ASCENDING) {
      if (sortBy === SortBy.PRODUCT) {
        return SortUtils.sortStrings(a[1].product, b[1].product)
      }
      else if (sortBy === SortBy.LICENSE_TYPE) {
        return SortUtils.sortStrings(a[1].licenseType, b[1].licenseType)
      }
      else if (sortBy === SortBy.LICENSE_MODEL) {
        return SortUtils.sortStrings(a[1].licenseModel, b[1].licenseModel)
      }
      else if (sortBy === SortBy.LICENSE_EXPIRY) {
        return SortUtils.sortDates(a[1].licenseExpiry, b[1].licenseExpiry)
      }
      else if (sortBy === SortBy.SUPPORT_EXPIRY) {
        return SortUtils.sortDates(a[1].supportExpiry, b[1].supportExpiry)
      }
      else if (sortBy === SortBy.QUANTITY) {
        return SortUtils.sortNumbers(a[1].quantity, b[1].quantity)
      }
    }
    else if (sortOrder === SortOrder.DESCENDING) {
      if (sortBy === SortBy.PRODUCT) {
        return SortUtils.sortStrings(b[1].product, a[1].product)
      }
      else if (sortBy === SortBy.LICENSE_TYPE) {
        return SortUtils.sortStrings(b[1].licenseType, a[1].licenseType)
      }
      else if (sortBy === SortBy.LICENSE_MODEL) {
        return SortUtils.sortStrings(b[1].licenseModel, a[1].licenseModel)
      }
      else if (sortBy === SortBy.LICENSE_EXPIRY) {
        return SortUtils.sortDates(b[1].licenseExpiry, a[1].licenseExpiry)
      }
      else if (sortBy === SortBy.SUPPORT_EXPIRY) {
        return SortUtils.sortDates(b[1].supportExpiry, a[1].supportExpiry)
      }
      else if (sortBy === SortBy.QUANTITY) {
        return SortUtils.sortNumbers(b[1].quantity, a[1].quantity)
      }
    }
    return 0
  }

  public static sortLicensesTable(a: any, b: any, sortOrder: SortOrder, sortBy: SortBy) {
    if (sortOrder === SortOrder.ASCENDING) {
      if (sortBy === SortBy.ORGANIZATION) {
        return SortUtils.sortStrings(a[1].accountName, b[1].accountName)
      }
      else if (sortBy === SortBy.DEAL) {
        return SortUtils.sortStrings(a[1].dealId, b[1].dealId)

      }
      else if (sortBy === SortBy.DEAL_TYPE) {
        return SortUtils.sortStrings(a[1].licenseType, b[1].licenseType)
      }
      else if (sortBy === SortBy.RENEWAL_DATE) {
        return SortUtils.sortDates(a[1].supportRenewalDate, b[1].supportRenewalDate)
      }
    }
    else {
      if (sortBy === SortBy.ORGANIZATION) {
        return SortUtils.sortStrings(b[1].accountName, a[1].accountName)
      }
      else if (sortBy === SortBy.DEAL) {
        return SortUtils.sortStrings(b[1].dealId, a[1].dealId)
      }
      else if (sortBy === SortBy.DEAL_TYPE) {
        return SortUtils.sortStrings(b[1].licenseType, a[1].licenseType)
      }
      else if (sortBy === SortBy.RENEWAL_DATE) {
        return SortUtils.sortDates(b[1].supportRenewalDate, a[1].supportRenewalDate)
      }
    }

    return 0
  }
}